"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PaperTitle;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _excluded = ["titleKey"];
function PaperTitle(_ref) {
  var titleKey = _ref.titleKey,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_material.Typography, (0, _extends2.default)({
    variant: "h6"
  }, rest), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: titleKey
  }));
}